import React, { useEffect, useState } from "react";
import Header from "../Header/Index.js";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FlashMessage from "../FlashMessage/FlashMessage.js";
import { Upload, Image } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Button from "../../commonComponents/Button.js";
var { apiRequest } = require("../Api/Service.js");
var {
  UpdateExtra,
  whitelabelListEndpoint,
  ExtraWhitelableuserLsting,
} = require("../Api/ApiRoutes.js");
const Helper = require("../Helper.js");

const initialState = {
  isError: false,
  errors: [],
  isSuccess: false,
  success: "",
  disable: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_SUCCESS":
      return {
        ...state,
        isSuccess: true,
        success: action.payload,
        disable: true,
      };
    case "FETCH_ERROR":
      return {
        ...state,
        isError: true,
        errors: action.payload,
        disable: false,
      };
    case "DEFAULT":
      return {
        disable: action.payload,
      };
    default:
      return state;
  }
};

function AddExtra() {
  const [LocalState, Localdispatch] = React.useReducer(reducer, initialState);
  const [whitelabelList, setWhitelabelList] = useState([]);
  const [extraFields, setExtraFields] = useState([]);
  const [labelId, setLabelId] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [isPreviewVisible, setPreviewVisible] = useState(false);

  let user = Helper.getStorageData("SESSION");
  const permissions = user.permissions;
  const DetailSchema = Yup.object().shape({
    start_date: Yup.string().required("This Field is Required"),
  });

  useEffect(() => {
    if (user.type !== "whitelabel") {
      handleWhitelabelList();
    } else {
      setLabelId(user.label_id);
      handleExtras(user.label_id);
    }
  }, []);
  const handleWhitelabelList = (event) => {
    apiRequest(
      whitelabelListEndpoint.method,
      whitelabelListEndpoint.url + `per_page=-1`
    )
      .then((response) => {
        if (response.data.code === 200) {
          setWhitelabelList(response.data.data);
        } else {
          console.log("Failure", response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveData = async () => {
    const form_data = new FormData();
    const extras =
      extraFields.length > 0
        ? extraFields.map((item) => ({ ...item, image: undefined }))
        : "";

    const images =
      extraFields.length > 0
        ? extraFields.map((item, index) => {
          if (item?.image?.length > 0) {
            if (item.image[0].originFileObj) {
              return { [index]: item.image[0].originFileObj };
            } else {
              return { [index]: item.image[0].url };
            }
          }
          return undefined;
        })
        : [];

    images?.length > 0 &&
      images.forEach((imageObj) => {
        if (imageObj) {
          const index = Object.keys(imageObj)[0];
          const binaryImage = imageObj[index];
          form_data.append(`extra-image[${index}]`, binaryImage);
        }
      });

    form_data.append("extras", [JSON.stringify(extras)]);

    Localdispatch({ type: "DEFAULT", payload: true });
    apiRequest(UpdateExtra.method, UpdateExtra.url + `${labelId}`, form_data)
      .then((response) => {
        if (response.data.code === 200) {
          Localdispatch({
            type: "FETCH_SUCCESS",
            payload: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Localdispatch({
          type: "FETCH_ERROR",
          payload: error.response.data.data,
        });
        window.scrollTo(500, 0);
      });
  };

  const handelExtraFields = (index, key, event) => {
    const values = [...extraFields];
    switch (key) {
      case "title":
      case "price":
      case "title_en":
      case "title_es":
      case "short_description_en":
      case "short_description_et":
      case "long_description_en":
      case "long_description_et":
        values[index][key] = event.target.value;
        break;
      case "is_default":
      case "is_vat":
      case "is_daily":
        values[index][key] = event.target.checked;
        break;
      case "type":
        values[index].type = event;
        break;
      case "image":
        if (event.status === "removed") {
          values[index].image = [];
        } else {
          const _file = { ...event, status: "done" };
          values[index].image = [_file];
        }
        break;

      default:
        break;
    }

    setExtraFields(values);
  };

  const handleAdditionalFields = () => {
    if (labelId === "") {
      return false;
    }
    setExtraFields([
      ...extraFields,
      {
        title: "",
        title_en: "",
        title_es: "",
        price: 0,
        is_daily: false,
        is_default: false,
        is_vat: false,
        type: "1",
        short_description_en: "",
        short_description_et: "",
        long_description_en: "",
        long_description_et: "",
        image: [],
      },
    ]); // Add a new empty input field to the state
  };

  const handleRemoveAdditionalFields = (index) => {

    let delete_Extra = window.confirm(
      "Are you sure you want to delete this record!"
    );
    if (delete_Extra) {

      const values = [...extraFields];
      values.splice(index, 1); // Remove the input field at the given index
      setExtraFields(values);
    }

  };

  const handleWhitelabelChange = (event) => {
    let id = event.target.value;
    setLabelId(id);
    handleExtras(id);
  };

  const handleExtras = (id) => {
    apiRequest(
      ExtraWhitelableuserLsting.method,
      ExtraWhitelableuserLsting.url + `${id}`
    )
      .then((response) => {
        if (response.data.code === 200) {
          setExtraFields([...extraFields, {}]);
          if (response.data.data.length === 0) {
            setExtraFields([
              ...extraFields,
              {
                title: "",
                title_en: "",
                title_es: "",
                price: 0,
                is_daily: false,
                is_default: false,
                is_vat: false,
                type: "1",
                short_description_en: "",
                short_description_et: "",
                long_description_en: "",
                long_description_et: "",
                image: null,
              },
            ]);
          } else {
            const data = response.data.data.map((item, index) => {
              return {
                ...item,
                image: item.image
                  ? [
                    {
                      uid: index,
                      name: `image${index}.png`,
                      status: "done",
                      url: item.image,
                    },
                  ]
                  : [],
              };
            });
            setExtraFields(data);
          }
        } else {
          console.log("Failure", response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImgPreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(!isPreviewVisible);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  return (
    <React.Fragment>
      <div id="content">
        <Header showSearch={false} showAdvanceSearch={false} />

        <div className="p-4">
          <h4 className="mb-3">Extra</h4>
          <div className="container-fluid">
            <div className="row">
              <Formik
                validateOnChange={false}
                validationSchema={DetailSchema}
                initialValues={{}}
                onSubmit={() => {
                  saveData()
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  isSubmitting,
                  setFieldValue,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form className="mt-2 w-100">
                    <FlashMessage
                      success={LocalState.success}
                      isSuccess={LocalState.isSuccess}
                      isError={LocalState.isError}
                      errors={LocalState.errors}
                    />

                    <div className="row mb-3 ">
                      {user.type !== "whitelabel" && (
                        <div className="col-md-6">
                          <div className="">
                            <label className="form-label">WhiteLabel</label>
                            <select
                              className={`form-control dropdown-height ${errors.label_id ? "error" : ""
                                }`}
                              name="label_id"
                              value={values.label_id}
                              onChange={(e) => {
                                values.vehicle_id = "";
                                handleWhitelabelChange(e);
                                handleChange(e);
                              }}
                            >
                              {" "}
                              <option value="">Select WhiteLabel</option>
                              {whitelabelList &&
                                whitelabelList.map((record, index) => (
                                  <option value={record.id} key={index}>
                                    {record.name}
                                  </option>
                                ))}
                            </select>
                            {errors.label_id && (
                              <div className="ft-14 mt-1 red">
                                {errors.label_id}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="col-md-6 mt-4">
                        <i
                          className="fas fa-plus-circle hover mt-3"
                          style={{
                            fontSize: "30px",
                            color: user.background_color,
                            cursor: "pointer",
                          }}
                          onClick={handleAdditionalFields}
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    {extraFields.map((inputValue, index) => (
                      <div
                        className="row border border-secondary m-1"
                        key={index}
                      >
                        <div className="form-group col-md-3">
                          <div className="">
                            <label
                              className="form-check-label mt-n2"
                              for="inlineCheckbox2"
                            >
                              Extra Title
                            </label>
                            <input
                              type="text"
                              value={inputValue?.title}
                              name="title"
                              onChange={(event) => {
                                handelExtraFields(index, "title", event);
                              }}
                              placeholder="Add New Extra"
                              className={`mb-3 form-control form-control-user ${errors.server_path ? "error" : ""
                                }`}
                            />
                          </div>
                        </div>

                        <div className="form-group col-md-3">
                          <div className="">
                            <label
                              className="form-check-label mt-n2"
                              for="inlineCheckbox2"
                            >
                              Extra Price
                            </label>
                            <input
                              type="text"
                              value={inputValue?.price}
                              name="price"
                              onChange={(event) => {
                                handelExtraFields(index, "price", event);
                              }}
                              placeholder="Price"
                              className={`mb-3 form-control form-control-user ${errors.server_path ? "error" : ""
                                }`}
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-3 mt-3">
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="type"
                              id="dailyPrice"
                              value="1"
                              checked={inputValue.type === "1"}
                              onChange={(event) => {
                                handelExtraFields(
                                  index,
                                  "type",
                                  event.target.value
                                );
                              }}
                            />
                            <label class="form-check-label" for="dailyPrice">
                              Daily price
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="type"
                              id="totalPrice"
                              value="2"
                              checked={inputValue.type === "2"}
                              onChange={(event) => {
                                handelExtraFields(
                                  index,
                                  "type",
                                  event.target.value
                                );
                              }}
                            />
                            <label class="form-check-label" for="totalPrice">
                              Total Price
                            </label>
                          </div>

                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="type"
                              id="singleItem"
                              checked={inputValue.type === "3"}
                              value="3"
                              onChange={(event) => {
                                handelExtraFields(
                                  index,
                                  "type",
                                  event.target.value
                                );
                              }}
                            />
                            <label class="form-check-label" for="singleItem">
                              Single item
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="type"
                              id="multipeItems"
                              checked={inputValue.type === "4"}
                              value="4"
                              onChange={(event) => {
                                handelExtraFields(
                                  index,
                                  "type",
                                  event.target.value
                                );
                              }}
                            />
                            <label class="form-check-label" for="multipeItems">
                              Multiple items
                            </label>
                          </div>
                        </div>
                        <div className="form-group col-md-2 mt-3">
                          <div className=" form-check form-check-inline">
                            <input
                              className="form-check-input"
                              name='is_vat'
                              type="checkbox"
                              onChange={(event) => {
                                handelExtraFields(index, 'is_vat', event);
                              }}
                              checked={inputValue?.is_vat ? inputValue.is_vat : false}
                              value={inputValue?.is_vat ? inputValue.is_vat : false}
                            />
                            <label className="form-check-label mt-n2" for="inlineCheckbox1">+Vat</label>
                          </div>
                          <div className=" form-check form-check-inline">
                            <input
                              className="form-check-input"
                              name='is_default'
                              type="checkbox"
                              onChange={(event) => {
                                handelExtraFields(index, 'is_default', event);
                              }}
                              checked={inputValue?.is_default ? inputValue.is_default : false}
                              value={inputValue?.is_default ? inputValue.is_default : false}
                            />
                            <label className="form-check-label mt-n2" for="inlineCheckbox2">Default</label>
                          </div>
                        </div>

                        {Helper.getPermissions(
                          "extras-delete",
                          permissions && permissions,
                          user.type
                        ) && (
                            <div className="form-group col-md-3">
                              <div className="">
                                <div className="pl-5 pr-4 pt-2">
                                  <i
                                    className="fas fa-minus hover"
                                    style={{
                                      fontSize: "30px",
                                      color: user.background_color,
                                      cursor: "pointer",
                                    }}
                                    aria-hidden="true"
                                    onClick={(event) => {
                                      handleRemoveAdditionalFields(index, event);
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          )}

                        <div className="form-group col-md-6">
                          <label className="form-label">ENG</label>
                          <input
                            type="text"
                            value={inputValue?.title_en}
                            name="title_en"
                            onChange={(event) => {
                              handelExtraFields(index, "title_en", event);
                            }}
                            placeholder="English"
                            className={`mb-3 form-control form-control-user ${errors.server_path ? "error" : ""
                              }`}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label className="form-label">EST</label>
                          <input
                            type="text"
                            value={inputValue?.title_es}
                            name="title_es"
                            onChange={(event) => {
                              handelExtraFields(index, "title_es", event);
                            }}
                            placeholder="Estonian"
                            className={`mb-3 form-control form-control-user ${errors.server_path ? "error" : ""
                              }`}
                          />
                        </div>

                        <div className="form-group col-md-12">
                          Image Upload
                          <Upload
                            accept="image/png, image/jpeg"
                            customRequest
                            listType="picture-card"
                            fileList={inputValue.image}
                            onPreview={handleImgPreview}
                            onChange={(file) => {
                              handelExtraFields(index, "image", file.file);
                            }}
                            showUploadList={{
                              showPreviewIcon: true,
                              showRemoveIcon: true,
                            }}
                          >
                            {uploadButton}
                          </Upload>
                          <Image
                            width={200}
                            style={{
                              display: "none",
                              transform: `rotate(90deg)`,
                            }}
                            preview={{
                              visible: isPreviewVisible,
                              onVisibleChange: (visible, prevVisible) =>
                                setPreviewVisible(visible),
                            }}
                            src={previewImage}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label className="form-label">
                            Short Description (EN)
                          </label>
                          <input
                            type="text"
                            value={inputValue?.short_description_en}
                            name="short_description_en"
                            onChange={(event) => {
                              handelExtraFields(
                                index,
                                "short_description_en",
                                event
                              );
                            }}
                            placeholder="Short Description in English"
                            className={`mb-3 form-control form-control-user ${errors.short_description_en ? "error" : ""
                              }`}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label className="form-label">
                            Short Description (ET)
                          </label>
                          <input
                            type="text"
                            value={inputValue?.short_description_et}
                            name="short_description_et"
                            onChange={(event) => {
                              handelExtraFields(
                                index,
                                "short_description_et",
                                event
                              );
                            }}
                            placeholder="Short Description in Estonian"
                            className={`mb-3 form-control form-control-user ${errors.short_description_et ? "error" : ""
                              }`}
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label
                            className="form-label"
                            for="long_description_en"
                          >
                            Long Description (EN)
                          </label>
                          <textarea
                            id="long_description_en"
                            name="long_description_en"
                            placeholder="Enter Description in English"
                            value={inputValue?.long_description_en}
                            onChange={(event) => {
                              handelExtraFields(
                                index,
                                "long_description_en",
                                event
                              );
                            }}
                            className={`mb-3 form-control form-control-user ${errors.long_description_en ? "error" : ""
                              }`}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label className="form-label">
                            Long Description (ET)
                          </label>
                          <textarea
                            id="long_description_et"
                            name="long_description_et"
                            placeholder="Enter Description in Estonian"
                            value={inputValue?.long_description_et}
                            onChange={(event) => {
                              handelExtraFields(
                                index,
                                "long_description_et",
                                event
                              );
                            }}
                            className={`mb-3 form-control form-control-user ${errors.long_description_et ? "error" : ""
                              }`}
                          />
                        </div>
                      </div>
                    ))}
                    {Helper.getPermissions(
                      "extras-update",
                      permissions && permissions,
                      user.type
                    ) && (
                        <div className="row mt-5 float-right">
                          <div className="form-row mt-4">
                            <div className="form-group d-flex justify-content-end col-md-12">
                              <button
                                type="submit"
                                className="btn-submit"
                                onClick={saveData}
                                style={{ backgroundColor: user.background_color }}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AddExtra;
